export default __webpack_public_path__ + "static/media/party-mode-icon.1dc935e1.png";